import { createFileRoute } from '@tanstack/react-router';

import { Courses } from '@/features/courses/Courses';

export const Route = createFileRoute('/_authenticated/courses/')({
  component: Courses,
});
